export const MODIFICATIONS = {
  TYPE_MESH: 1,
  TYPE_CUSTOM_MODELS: 2,
}
